// Duplicated from scene/map/utils/consts to avoid a cross-scene import; shared by the route
// scene's multi-pin and lasso record lists.
export const MULTI_PIN_RECORDS_PAGE_SIZE = 50;
